import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import {
  Typography,
  PLATFORM_THEME_COLORS,
  Form,
  SelectInput,
  Button,
  ButtonsWrapper,
} from '@thinknet-gmbh/platform-common-ui';

import { HeaderContainer, WarningContainer } from './transfer-employees.styles';
import { ITransferEmployeesProps } from './transfer-employees.interfaces';

const TransferEmployees: FC<ITransferEmployeesProps> = ({
  isCloseModalAttempt,
  closeModalAttempt,
  employees,
}) => {
  const { t } = useTranslation(['settings', 'common']);

  return (
    <div>
      <HeaderContainer>
        <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
          {t('settings:company.labels.transferEmployeesDescription')}
        </Typography>

        <Typography>
          {t('settings:company.labels.numberOfEmployees')} <span>{employees.length}</span>
        </Typography>
      </HeaderContainer>

      {isCloseModalAttempt && (
        <WarningContainer>
          <Typography weight="bold" fontColor={PLATFORM_THEME_COLORS.tone.red}>
            {t('settings:permissionGroupSettings.notifications.closeWindow')}
          </Typography>
          <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
            {t('settings:company.notifications.closeTransferEmployees')}
          </Typography>
        </WarningContainer>
      )}

      <Form layout="vertical" onFinish={values => console.log(values)}>
        {employees.map(({ firstName, lastName, _id }) => (
          <Form.Item key={_id} label={`${firstName} ${lastName}`}>
            <SelectInput placeholder={t('settings:company.placeholders.chooseCompany')}>
              {}
            </SelectInput>
          </Form.Item>
        ))}
        <ButtonsWrapper>
          <Button htmlType="submit" type="primary">
            {t('common:buttons.save')}
          </Button>
          <Button onClick={() => closeModalAttempt()}>{t('common:buttons.cancel')}</Button>
        </ButtonsWrapper>
      </Form>
    </div>
  );
};

export default TransferEmployees;
